import axios from "axios";
import {
  PRODUCTS_ARE_FETCHING,
  PRODUCTS_FETCHED_SUCCESS,
  PRODUCTS_FETCHED_ERROR,
  PRODUCTS_CLEAR_ERROR,
} from "../../../constants/actionTypes/actionTypes";

export const getProductsInProgress = () => ({
  type: PRODUCTS_ARE_FETCHING,
});

export const getProductsSuccess = (content) => ({
  type: PRODUCTS_FETCHED_SUCCESS,
  payload: content,
});

export const getProductsError = (content) => ({
  type: PRODUCTS_FETCHED_ERROR,
  payload: content,
});

export const clearProductsError = () => ({
  type: PRODUCTS_CLEAR_ERROR,
});

export const getProductsAndPlans = () => (dispatch, getState) => {
  const {
    paths: { api },
  } = getState();
  const url = `${api}/v3/products`;
  dispatch(getProductsInProgress());
  return axios
    .get(url)
    .then((response) => dispatch(getProductsSuccess(response.data)))
    .catch((error) => {
      const { data } = error.response;
      dispatch(
        getProductsError({
          status: error.response.status,
          errorMessage:
            data && data.body ? data.body.endUserMessage : error.toString(),
        }),
      );
    });
};
